//Global Imports
import React, { useState, useEffect } from "react";
import clsx from "clsx";
import Countdown, { zeroPad } from "react-countdown";
//End Global Imports

//Local Imports
import Button from "../../../components/ui/Button";
import OtpBox from "../../../components/ui/OtpBox";
import { IStepTwo } from "./OtpPhase";
// import ErrorField from "../../../components/ui/ErrorField";
//End Local Imports

const OtpPhaseNew: React.FC<IStepTwo.IProps> = ({
  otpValue,
  otpError,
  setOtpValue,
  verifyOTP,
  isOTPVerified,
  verifyOtpError = "",
  resendOTP,
  //dateKey,
  buttonText,
  title,
  rootClass,
  isLoading,
}) => {
  const [date, setDate] = useState(Date.now() + 120000);
  const [resetKey, setResetKey] = useState(0);
  const [otpLoader, setOtpLoader] = useState<boolean>(false);

  useEffect(() => {
    resetTimer();
  }, []);

  const resetTimer = () => {
    const newDate = Date.now() + 120000;
    setDate(newDate);
    setResetKey((prevKey) => prevKey + 1);
  };

  const handleResendOTP = async () => {
    setOtpLoader(true);
    try {
      resendOTP();
      resetTimer();
    } catch (error) {
      console.error(error);
    } finally {
      setOtpLoader(false);
    }
  };

  return (
    <div className={clsx(rootClass, "flex flex-col items-start w-full")}>
      <div className="flex flex-col items-start w-full">
        <div className={clsx(title ? "hidden" : "xl:mb-5 lg:my-2 text-left")}>
          <div className="mb-3 xl:text-xl lg:text-[16px] font-semibold text-[#000] font-inter">
            Enter OTP <span className="text-red-100">*</span>
          </div>
          <div className="xl:text-lg lg:text-sm font-normal font-inter text-[#000]">
            A 6-digit OTP is sent to your phone number.
          </div>
        </div>
        <div
          className={clsx(
            title ? "text-sm md:text-base font-semibold text-black font-ssp " : "hidden"
          )}
        >
          {title}
        </div>
        <div className="w-full">
          <OtpBox
            updateValue={(value) => setOtpValue(value)}
            errorMsg={verifyOtpError}
            errorMessageClassname={
              otpError ? "border-none bg-[transparent] text-center" : "bg-[#fff] text-center"
            }
            numberOfBoxes={6}
            otpBoxClassName="!w-[52px] !bg-[#f5f5f5]/10 !border-[0.5px] !border-[#d9d9d9] !rounded-xl !text-[#C8C8C8]"
          />
        </div>
      </div>
      {/* <div className={clsx(verifyOtpError !== "" ? "flex text-center w-full" : "hideden")}>
        <ErrorField errorMessage={verifyOtpError} />
      </div> */}
      <div
        className={clsx(
          isOTPVerified ? "flex" : "hidden",
          "text-success font-ssp font-medium text-sm mt-3"
        )}
      >
        OTP Verified
      </div>
      <div
        className={clsx(
          otpValue.length >= 1 ? "mt-[12px]" : "mt-[12px]",
          isOTPVerified && "mt-[28px]",
          "flex flex-col items-start justify-start h-full w-full"
        )}
      >
        <div>
          <Countdown
            key={resetKey}
            date={date}
            renderer={({ minutes, seconds, completed }) => {
              if (completed) {
                return (
                  <Button
                    isLoading={otpLoader}
                    className="z-10 bg-transparent xl:text-xl lg:text-base font-bold text-[#969696] cursor-pointer font-inter"
                    onClickHandler={handleResendOTP}
                  >
                    Resend OTP
                  </Button>
                );
              } else {
                return (
                  <div className="flex items-center gap-2">
                    <div className="xl:text-xl lg:text-base font-bold text-[#969696]">
                      Resend OTP
                    </div>
                    <div className={"xl:text-xl lg:text-base font-bold text-[#969696] font-inter"}>
                      {zeroPad(minutes)} :{zeroPad(seconds)}
                    </div>
                  </div>
                );
              }
            }}
          />
        </div>

        <Button
          bgColor={`${otpValue.length == 6 ? "bg-primary-1050" : "bg-primary-1050"}`}
          fontStyle={{
            fontFamily: "font-inter",
            fontSize: "xl:text-xl lg:text-base",
            fontWeight: "font-semibold",
            fontColor: "text-[#fff] disabled:text-[#fff]",
          }}
          borderStyle={{
            borderWidth: "border",
            borderRadius: "rounded",
            borderColor: "border-[#0F5BF1] disabled:border-[#9F9F9F]",
          }}
          className="w-full xl:h-[46px] lg:h-[40.104px] disabled:opacity-50 disabled:cursor-not-allowed xl:mt-9 lg:mt-4"
          disabled={otpValue.length < 6 || otpLoader}
          onClickHandler={verifyOTP}
          isLoading={isLoading}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default OtpPhaseNew;
